import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';
import { getProfileChecks } from '../utils/profileCompletion';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// complete defaults to true (fail-open) so we never trap a user due to a
// loading/network error — only a confirmed-incomplete parent profile locks.
const Ctx = createContext({ loading: true, complete: true, missing: [], refresh: () => {} });

export const useProfileCompletion = () => useContext(Ctx);

export function ProfileCompletionProvider({ children }) {
  const { user, getAuthHeaders } = useAuth();
  const [state, setState] = useState({ loading: true, complete: true, missing: [] });

  const refresh = useCallback(async () => {
    // Only parents are gated. Everyone else is always "complete".
    if (!user || user.user_type !== 'parent') {
      setState({ loading: false, complete: true, missing: [] });
      return;
    }
    try {
      const resp = await axios.get(`${API}/profile/${user.user_id}`, { headers: getAuthHeaders() });
      const p = resp.data.profile || {};
      const checks = getProfileChecks(user, p);
      const missing = checks.filter((c) => !c.done);
      setState({ loading: false, complete: missing.length === 0, missing });
    } catch {
      // fail-open: do not trap the user on a transient error
      setState({ loading: false, complete: true, missing: [] });
    }
  }, [user, getAuthHeaders]);

  useEffect(() => { refresh(); }, [refresh]);

  return <Ctx.Provider value={{ ...state, refresh }}>{children}</Ctx.Provider>;
}
